/* global axios */
import ApiClient from './ApiClient';

class ExpertsAPI extends ApiClient {
  constructor() {
    super('experts', { accountScoped: true });
  }

  addMember(expertId, { user_id, role }) {
    return axios.post(`${this.url}/${expertId}/add_member`, { user_id, role });
  }

  removeMember(expertId, userId) {
    return axios.delete(`${this.url}/${expertId}/remove_member`, {
      data: { user_id: userId },
    });
  }

  addInbox(expertId, inboxId) {
    return axios.post(`${this.url}/${expertId}/add_inbox`, {
      inbox_id: inboxId,
    });
  }

  removeInbox(expertId, inboxId) {
    return axios.delete(`${this.url}/${expertId}/remove_inbox`, {
      data: { inbox_id: inboxId },
    });
  }
}

export default new ExpertsAPI();
